<template>
<div class='GUI_cont' ref="GUI_cont">
  <div class="topRightMenu" :style="'transform:scale('+(statsScale/100)+'); top:'+(statsScale*2)+'px'"> 
      <div style="min-width:120px;" @click="closePanel" class="glowBorder topRightBtn">Close Research</div>
       <div v-if="!showAll && debug" @click="toggleDocs" class="glowBorder topRightBtn">All Docs</div>
       <div v-if="showAll && debug" @click="toggleDocs" class="glowBorder topRightBtn">Found Docs</div>
       <router-link v-if="debug" to="/documents"> <div  class="glowBorder topRightBtn">Edit Docs</div></router-link>
       <div @click="planDive" class="glowBorder topRightBtn">Plan Dive</div>
   <div  class="glowBorder topRightBtn" @click="planExhibit">Plan Exhibition</div>
    </div>
<div class='shipInfo' :style="'transform:scale('+(statsScale/100)+') translateX('+(-104+statsScale)*.5+'%) translateY('+(-100+statsScale)/2+'%)'">
 
   <div v-if="wreck" class="shipStats glowBorder" > 
  
      <div class="infoText glowBorder NB BR" style="width:calc(50% - 16px);">{{wreckInfo[0].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[0].value)">{{wreckInfo[0].value}}</span></div>
      <div class="infoText glowBorder NB BB" style="width:calc(50% - 12px);">{{wreckInfo[1].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[1].value)">{{wreckInfo[1].value}}</span></div>
      <div class="infoText glowBorder NB BB" style="width:calc(100% - 12px);">{{wreckInfo[2].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[2].value)">{{wreckInfo[2].value}}</span></div>
      <div class="holoVid" style="height:350px; overflow:hidden;">
        <video ref="wreckVid" width=600 loop autoplay playsinline mute :src="wreckVid" style="position:relative;top:-50px;"></video>
      </div>
      <div class="infoText glowBorder NB TBR" style="width:calc(50% - 16px);">{{wreckInfo[3].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[3].value)">{{wreckInfo[3].value}}</span></div>
      <div class="infoText glowBorder NB TB" style="width:calc(50% - 12px);">{{wreckInfo[4].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[4].value)">{{wreckInfo[4].value}}</span></div>
      <div class="infoText glowBorder NB BB" style="width:calc(100% - 12px);">{{wreckInfo[5].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[5].value)">{{wreckInfo[5].value}}</span></div>
      <div class="infoText glowBorder NB BB" style="width:calc(100% - 12px);">{{wreckInfo[6].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[6].value)">{{wreckInfo[6].value}}</span></div>
      <div class="infoText glowBorder NB BR" style="width:calc(50% - 16px);">{{wreckInfo[7].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[7].value)">{{wreckInfo[7].value}}</span></div>
      <div class="infoText glowBorder NB BB" style="width:calc(50% - 12px);">{{wreckInfo[8].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[8].value)">{{wreckInfo[8].value}}</span></div>
      <div class="infoText glowBorder NB BB" style="width:calc(100% - 12px);">{{wreckInfo[9].entry}}: <span :class="'infoTextMain'+isKnown(wreckInfo[9].value)">{{wreckInfo[9].value}}</span></div>
    
    </div>
     <VueDragResizeAndRotate v-if="false" id="wreckMenu" ref="wreckMenu" :w="240"  :bounds="{parent: true}" :sticks="[]" class="menuDragger" style="top:0px;right:30px;height:160px;min-width:200px; background: transparent;">
       <div class="mainMenu glowBorder">
       
        <GlowMenu   @menuChange="menuChange" :values="wrecks">Wrecks</GlowMenu> 
       
      </div>     
    </VueDragResizeAndRotate>
   
   
    <div v-if="wreck" >
    <ConnectedDisk  v-for="(node,n) in dataNodes" :key="'node'+n"  :node="node" :index="node.index" :anchor="{x:628,y:240+n*10}" :dragging="doDrag"></ConnectedDisk>
    <ConnectedStack v-for="(node,nc) in dataNodes" :key="'card'+nc" :cards="node.children" :comp="node.name" :pos="{x:920+nc*20,y:50+nc*120}" :parentNode="node" :ax="nodePos(nc)"></ConnectedStack>
</div>

   </div>
    
   </div>
</template>

<script>
import notification from '@/components/notification'
import VueDragResizeAndRotate from 'vue-drag-resize-and-rotate'
import * as firebase from 'firebase'
import InfoDisk from "@/components/InfoDisk.vue"
import GlowMenu from "@/components/GlowMenu.vue"
import GlowBtn from "@/components/glowBtn.vue"
import Connector from "@/components/Connector.vue"
import ConnectedElement from "@/components/ConnectedElement.vue"
import ConnectedDisk from "@/components/ConnectedDisk.vue"
import ConnectedStack from "@/components/ConnectedStack.vue"

export default {
  name: "ShipInfo",
  components: {
    GlowMenu,
    GlowBtn,
    Connector,
    ConnectedElement,
    ConnectedDisk,
    ConnectedStack,
    InfoDisk,
    VueDragResizeAndRotate,
    notification,
    
  },
  props:["scSize"],
  data() {
    return {
      currentItem:null,
      zStack:1,
      statsScale:100,
      shuffle:true,
      actionMenu:[{name:"Close"}]
    };
  },
  mounted(){
    console.log("---------- WRECKS MOUNTED SHIP INFO ")
     this.$store.commit("setSettingsClass","settingsIcon")
    for(var n in this.dataNodes){
      this.dataNodes[n].offset={x:0,y:0}
    }
    this.$store.dispatch("loadWrecks")
    this.setStatsScale()
    window.onresize =this.doResize
    console.log("MOUNTED",window,this.doResize)
    this.doResize()
    this.shuffle=true
  },
  //445959b8-c207-4631-8bf4-b458b7914205
  //445959b8-c207-4631-8bf4-b458b7914205
  computed:{
   viewedDocs(){
      return this.$store.getters.getViewedDocs
      
    },
     fireBaseLoc(){
					return this.$store.getters.getFireBaseLoc					
				},
    screenVis(){
      return this.$parent.screenVis
    },
    volume(){
      return this.$store.getters.getVolume
    },
    debug(){
				return this.$store.getters.getDebug
		},
    showAll(){
       return this.$store.getters.getPlayerAll
    },
    knownDocs(){
      console.log("knownDocs---",this.$store.getters.getKnownDocs)
      
        return this.$store.getters.getKnownDocs
      
      
    },
    evidences(){
      return this.$store.getters.getEvidences
    },
      wreckInfo(){
        let name="Unknown"
        let info=[]
        let entry
        if(this.wreck){
          name=this.wreck.name
          if(this.wreck.info){
            for(var i in this.wreck.info){
              entry=this.wreck.info[i].split(":")
              if(this.knownDocs && this.knownDocs.includes(entry[0])){
                info.push({entry:entry[0],value:entry[1]})
              }else{
                info.push({entry:entry[0],value:"Unknown"})
              }
              
            }
            return info
          }
        }
        return [{entry:"Wreck",value:name},
        {entry:"Date Wrecked",value:"Unknown"},
        {entry:"Location",value:"Unkown"},
        {entry:"Built",value:"Unkown"},
        {entry:"Where",value:"Unkown"},
        {entry:"Construction Type",value:"Unkown"},
        {entry:"Materials",value:"Unkown"},
        {entry:"Length",value:"Unkown"},
        {entry:"Width",value:"Unkown"},
        {entry:"Cargo",value:"Unkown"},
        {entry:"BluePrint",value:"Unkown"},
        ]
      },
     
    dataNodes(){
      let nodes=this.$store.getters.getNodes
      let node
      let child
      let self=this
      for(var n in nodes){
          node =nodes[n]
          for(var cn in nodes[n].children){
            child=nodes[n].children[cn]
            this.$set(child,"found",false)
            if(this.knownDocs && this.knownDocs.includes(child.id) || this.showAll){           
                this.$set(child,"found",true)
            }
          }
          if(node.children && this.shuffle){
            node.children= node.children.sort(function(a, b) {
            if(self.viewedDocs.includes(b.id) && !self.viewedDocs.includes(a.id)){
                return 1;
              }else{
                return -1;
              }
       
          });
         }
        
      }
      this.shuffle=false
      return nodes
    },
    wreckVid(){
      if(this.wreck && this.wreck.videoToken){
        if( this.$refs.wreckVid){
            this.$refs.wreckVid.volume=this.volume
        }
      //console.log("WRECK VID",this.wreck,this.wreckInfo)
      if(this.wreckInfo[10] && this.wreckInfo[10].value=="Unknown"){
        return this.fireBaseLoc+"wrecks%2F"+"UnknownOutput.mp4"
      }
      return this.fireBaseLoc+"wrecks%2F"+this.wreck.id+"%2Fpreview_"+this.wreck.id+".mp4"
      }
    },
    wreck(){
       return this.$store.getters.getWreck
    },
    wrecks(){
      console.log(this.$store.getters.getWrecks)
      return this.$store.getters.getWrecks
    },
    locationCount(){
      let locCount=0
     
      for(var l in this.wreck.locations){
       
        for(var k in this.knownDocs){
          if(this.wreck.locations[l].indexOf(this.knownDocs[k])>-1){
            console.log("found",this.wreck.locations[l].indexOf(this.knownDocs[k]))
            locCount++
          }
        }
      }
      return locCount
    },
     userData(){
      return this.$store.getters.getUserData
    },
    userIsLoaded(){
        return this.$store.getters.getUserIsLoaded
      },
  },
  methods:{
    doResize(){
      console.log("WRECK RESIZE")
      this.setStatsScale()
    },
    setStatsScale(){
      if(window.innerWidth<1200 || window.innerHeight<700){
         if(window.innerWidth/1200 < window.innerHeight/700){
            this.statsScale=Math.floor(window.innerWidth/12)
         }else{
           this.statsScale= Math.floor((window.innerHeight)/7)
         }
      }else{
        this.statsScale= 100
      }
    },
    isKnown(info){
      if(info!="Unknown"){
        return " known"
      }else{
        return ""
      }
    },
      planDive(){
        console.log(this.wreck)
        console.log(this.knownDocs)
        if(this.locationCount>0 || this.debug){
          if(!this.userIsLoaded){
           this.$store.dispatch("showBasicHelp",{text:"You need to be signed in if you want to save your progress",callBack:this.reallyPlan})
          }else{
            this.reallyPlan()
          }
            
        }else{
          this.$store.dispatch("showHelp",{id:"H801_cantPlan",shown:false,help:{}})
        } 
     }, 
      reallyPlan(){
        let tText= "Planning the dive"
        this.$store.dispatch('startTransition',{text:tText,to:"planning"})
      },
     planExhibit(){
        console.log(this.evidences)
        console.log(this.knownDocs)
       if(this.knownDocs && this.knownDocs.length>2 || this.debug){
          if(!this.userIsLoaded){
           this.$store.dispatch("showBasicHelp",{text:"You need to be signed in to have an exhibition"})
          }else{
            this.reallyExhibit()
          }
          
       }else{
          this.$store.dispatch("showHelp",{id:"H802_cantExhibit",shown:false,help:{}})
       }
     }, 
    reallyExhibit(){
        let tText= "The Exhibition Plan"
        this.$store.dispatch('startTransition',{text:tText,to:"exhibitPlan"})
      },
    toggleDocs(){
      this.$store.commit("setPlayersAll",!this.showAll)
    },
    closePanel(){
      this.$emit('closePanel')
    },
    nodePos(node){
      return this.dataNodes[node].dx
    },
    doDrag(prop,target){
      if(this.currentItem!=target.index){
        if(this.currentItem!=null){
          console.log(this.dataNodes)
          this.shuffle=true
        this.dataNodes[this.currentItem].selected=false
        }
         this.zStack++
         this.currentItem=target.index
          target.zDepth=this.zStack
      }
     
      this.$store.commit('setNodeOffset',{index:target.index,x:prop.x,y:prop.y})
    },
    nodeSelected(evnt){
      console.log("Node",evnt)
    },
    getNode(parentN){
      if(this.$refs[parentN]){
        return this.$refs[parentN]
      }else{
        return null
      }
    },
    doMenu(value){
       console.log(value)
    },
    menuChange(value){
      console.log("SET WRECK",value)
      this.$store.commit("setWreck",value)
      console.log(value)
    },
    
    
    
  },
  watch:{
    
    scSize(val){
      this.doResize()
      
    },
    volume(val){
      if( this.$refs.wreckVid){
         this.$refs.wreckVid.volume=this.volume
      }
    
    },
     wrecks(val){
       
       if( this.$store.getters.getGameStatus && this.$store.getters.getGameStatus.activeWreck){
         this.$store.commit('setWreckByName', this.$store.getters.getGameStatus.activeWreck)
       }
     },
     screenVis(){
     
      if(this.wreck && this.wreck.unavailable && this.$parent.screenVis){
              this.$store.commit("setIsUnavailable",true)
            }
     },
    wreck(val){
      this.shuffle=true
      this.$store.commit('resetNodes')
      console.log("new wreck",val)
     
      for(var e in val.experts){
        this.$store.dispatch('loadExpert',val.experts[e].split(" ")[0])
      }
      
      this.$store.commit('setNodes',{type:"Experts",content:val.experts})
      console.log("WRECK",val.docs)
      for(var d in val.docs){
         console.log("WRECK",val.docs[d].split(" ")[0])
        this.$store.dispatch('loadDoc',val.docs[d].split(" ")[0])
      }
      this.$store.commit('setNodes',{type:"Documents",content:val.docs})

      for(var e in val.evidence){
        this.$store.dispatch('loadEvidence',val.evidence[e].split(" ")[0])
      }
      this.$store.commit('setNodes',{type:"Evidence",content:val.evidence})

      for(var m in val.maps){
        this.$store.dispatch('loadMap',val.maps[m].split(" ")[0])
      }
      this.$store.commit('setNodes',{type:"Environment",content:val.maps})

      for(var l in val.locations){
        this.$store.dispatch('loadLoc',val.locations[l].split(" ")[0])
      }
      
   
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";
.draggable{
  background: transparent;
  background: transparent!important;
  pointer-events: auto;
}
.infoText{
  display:inline-block;
  text-transform: uppercase;
  padding:6px;
  font-size:14px;
}
.glowBorder.BL{
  border-top:none;
  border-right:none;
}
.glowBorder.TB{
  border-radius:0px;
  border-left:none;
  border-right:none;
}
.glowBorder.BR{
  border-radius:0px;
  border-top:none;
  border-left:none;
}
.glowBorder.TBR{
  border-radius:0px;
  border-left:none;
}
.glowBorder.NB{
 background: transparent;
 box-shadow: none;
}
.glowBorder.BB{
  border-radius:0px;
  border:none;
  border-bottom:inherit;
}
.infoTextMain{
 
  font-size: 18px;
}
.infoTextMain.known{
   color:#00ffff;
}
.shipInfo {
  pointer-events:none;
  position:absolute;
  width: 100%;
  height: 100%;
}
.GUI_cont {
  position:absolute;
  width: 100%;
  height: 100%;
}
.shipStats{
  margin:30px;
  max-width:600px;
  min-height:600px;
}
.holoVid{
  opacity:0.7;
  box-shadow: 0px 0px 50px 0px inset;
}
.topRightMenu{
  font-weight: 600;
  position:absolute;
  transform-origin: top right;
  top:300px;
  right:30px;
  
  cursor:pointer;
}
.topRightBtn{
  margin-bottom:10px;
  padding:5px 20px;
  box-shadow:  0px 0px 20px 0px, 0px 0px 20px 0px inset;
  cursor:pointer;
}
.topRightBtn:hover{
   box-shadow: 0px 0px 20px 0px, 0px 0px 50px 0px inset;
}
.green-text{
  color:$green-text;
  text-shadow:$green-text 0px 0px 20px;
}
.teal-text{
  color:$teal-text;
  text-shadow:$teal-text 0px 0px 20px;
}
.orange-text{
  color:$orange-text;
  text-shadow:$orange-text 0px 0px 20px;
}

</style>
<style scoped>
.topRightMenu{
  font-weight: 600;
  position:absolute;
  transform-origin: top right;
  top:300px;
  right:30px;
  
  cursor:pointer;
}

</style>